<template>
    <div class="mdl-grid">
        <div class="mdl-cell--1-col-desktop mdl-cell--1-col-tablet mdl-cell--4-col-phone">
            <input type="text" placeholder="Kód" v-model="food.foodCode" @blur="save()"/>
        </div>
        <div class="mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--4-col-phone">
            <textarea placeholder="název" style="height: auto;" rows="4" v-model="food.name" @blur="save()"></textarea>
        </div>
        <div class="mdl-cell--1-col-desktop mdl-cell--1-col-tablet mdl-cell--2-col-phone">
            <input type="text" placeholder="Cena" v-model.number="food.price" @blur="save()"/>
        </div>
        <div class="mdl-cell--1-col-desktop mdl-cell--1-col-tablet mdl-cell--2-col-phone">
            <input type="text" placeholder="Cena s polévkou" v-model.number="food.priceWithSoup" @blur="save()"/>
        </div>
        <div class="mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--4-col-phone">
            <span v-for="(foodOption, optionIndex) in food.foodOptions" :key="foodOption.foodOptionId">
                <div class="mdl-chip mdl-chip--deletable mdl-shadow--2dp">
                    <span class="mdl-chip__text">{{ foodOption.foodOptionType.name }} ({{ foodOption.optionGroup }})</span>
                    <button type="button" class="mdl-chip__action" v-on:click="deleteFoodOption(optionIndex)">
                        <i class="material-icons">cancel</i>
                    </button>
                </div>
                &nbsp;
            </span>
            <div class="mdl-chip mdl-shadow--2dp cursor-hand" v-on:click="addFoodOption(food)">
                <span class="material-icons mdl-chip__text white">add</span>
            </div>
        </div>
        <div class="mdl-cell--2-col-desktop mdl-cell--1-col-tablet mdl-cell--2-col-phone">
            <check-box v-model="food.soupRequired"></check-box>
        </div>
        <div class="mdl-cell--1-col-desktop mdl-cell--1-col-tablet mdl-cell--2-col-phone">
            <i class="material-icons cursor-hand" v-on:click="deleteFood()">delete</i>
        </div>

        <modal :open-counter="optionModalOpen" :small="true">
            <food-option-select v-on:option-selected="foodOptionSelected"></food-option-select>
        </modal>
    </div>
</template>

<script>
    import CheckBox from "./widgets/CheckBox";
    import FoodOptionSelect from "./FoodOptionSelect";
    import Modal from "./widgets/Modal";

    export default {
        name: "FoodItemEditable",
        props: ['food'],
        components: {CheckBox, FoodOptionSelect, Modal},
        data: function() {
            return {
                optionModalOpen: 0,
                selectedFoodForOptionAdd: Object
            }
        },
        methods: {
            deleteFoodOption: function (foodOptionIndex) {
                this.food.foodOptions.splice(foodOptionIndex, 1);
                this.save();
            },
            deleteFood: function () {
                this.$emit("delete-food");
                this.save();
            },
            addFoodOption: function (food) {
                this.selectedFoodForOptionAdd = food;
                this.optionModalOpen++;
            },
            foodOptionSelected: function(option, group) {
                this.optionModalOpen--;
                this.selectedFoodForOptionAdd.foodOptions[this.selectedFoodForOptionAdd.foodOptions.length] = { foodOptionType: option, optionGroup: group };
                this.save();
            },
            save: function () {
                this.$emit("save");
            }
        }
    }
</script>

<style scoped>
    .cursor-hand {
        cursor: pointer;
    }

    input, textarea {
        background: transparent;
    }
</style>